import appActions from '../actions/actions';

// TODO: How to use combineReducers here?

const initialState = {
    vasModal: {
        currentPage: 1,
        travelInsurance: {
            formSelection: null,
            formSubmitted: false,
        },
        damageProtection: {
            formSelection: null,
            formSubmitted: false,
        },
    },
    reservationUpdateModalIsOpen: false,
    reservationUpdateSubmitted: false,
    reservationUpdateChanges: null,
    reservationUpdateCancelled: false,
    loyaltyBurnSelected: true,
    isHybridVasInterstitial: false,
    media: {images: [], thumbnailUrl: ''},
};

const actionHandlers = {
    [appActions.FETCH_CES_DATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            ...payload.response,
        };
    },
    [appActions.FETCH_CES_DATA_ERROR](state, {payload}) {
        return {
            ...state,
            ...payload.response,
        };
    },
    [appActions.SET_BILLING_NAME](state, action) {
        const newState = {};
        const billing = Object.assign({}, state.billing);

        billing[action.prop] = action.name;

        Object.assign(newState, state, {billing});
        return newState;
    },
    [appActions.SET_PURCHASER](state, action) {
        const newState = {};
        const checkoutPayload = Object.assign({}, state.checkoutPayload);

        checkoutPayload.purchaser[action.prop] = action.name;

        Object.assign(newState, state, {checkoutPayload});
        return newState;
    },
    [appActions.SIDEBAR_MODAL_OPEN](state, {isOpen}) {
        const modals = state.modals || {};
        Object.assign(modals, {
            sidebarModal: isOpen,
        });
        return {
            ...state,
            ...{
                modals,
            },
        };
    },
    [appActions.SIDEBAR_MODAL_CLOSE](state, {isOpen}) {
        const modals = state.modals || {};
        Object.assign(modals, {
            sidebarModal: isOpen,
        });
        return {
            ...state,
            ...{
                modals,
            },
        };
    },
    [appActions.TRIGGER_GLOBAL_ERROR](state, {globalError}) {
        return {
            ...state,
            globalError,
        };
    },
    [appActions.TRIGGER_PROPERTY_UNAVAILABLE_ERROR](
        state,
        {propertyUnavailableError}
    ) {
        return {
            ...state,
            propertyUnavailableError,
        };
    },
    [appActions.RESERVATION_MODAL_CLOSE](state, {submit}) {
        return {
            ...state,
            reservationUpdateModalIsOpen: false,
            reservationUpdateSubmitted: submit,
            reservationUpdateCancelled: !submit
                ? state.reservationUpdateChanges
                : null,
        };
    },
    [appActions.RESERVATION_MODAL_OPEN](state, {changes}) {
        return {
            ...state,
            reservationUpdateModalIsOpen: true,
            reservationUpdateChanges: changes,
            reservationUpdateCancelled: false,
        };
    },
    [appActions.SET_VAS_MODAL_FORM_SELECTION]: (state, action) => {
        return {
            ...state,
            vasModal: {
                ...state.vasModal,
                [action.payload.productCategory]: {
                    ...state.vasModal[action.payload.productCategory],
                    formSelection: action.payload.formSelection,
                },
            },
        };
    },
    [appActions.SET_VAS_MODAL_FORM_SUBMITTED]: (state, action) => {
        return {
            ...state,
            vasModal: {
                ...state.vasModal,
                [action.payload.productCategory]: {
                    ...state.vasModal[action.payload.productCategory],
                    formSubmitted: action.payload.formSubmitted,
                },
            },
        };
    },
    [appActions.SET_VAS_MODAL_PAGE_NUMBER]: (state, action) => {
        return {
            ...state,
            vasModal: {
                ...state.vasModal,
                currentPage: action.payload.pageNumber,
            },
        };
    },
    [appActions.SET_LOYALTY_BURN]: (state, action) => {
        return {
            ...state,
            loyaltyBurnSelected: action.payload.loyaltyBurnSelected,
        };
    },
    [appActions.SET_MEDIA]: (state, action) => {
        return {
            ...state,
            media: action.payload.media,
        };
    },
    [appActions.SET_VAS_STANDALONE_INTERSTITIAL]: (state, action) => {
        return {
            ...state,
            isHybridVasInterstitial: action.payload.isHybridVasInterstitial,
        };
    },
    [appActions.SET_VAS_AMOUNT]: (state, action) => {
        return {
            ...state,
            vas: {
                ...state.vas,
                [action.payload.vas?.productGuid]: action.payload.vas,
            },
        };
    },
};

const rootReducer = (state = initialState, action) => {
    if (typeof actionHandlers[action.type] === 'function') {
        return actionHandlers[action.type](state, action);
    }
    return state;
};

export default rootReducer;
